<template>
<span>
  <p><span style="font-size:10pt">Nach DIN EN 62305-2 oder IEC 62305-2</span></p>

  <ul>
    <li>
      <p><span style="font-size:10pt">Wird Blitzschutz ben&ouml;tigt oder nicht</span></p>
    </li>
    <li>
      <p><span style="font-size:10pt">Wenn Blitzschutz notwendig ist, in welcher Blitzschutzklasse</span></p>
    </li>
    <li>
      <p><span style="font-size:10pt">Notwendigkeit eines Blitzschutzpotenzialgleich</span></p>
    </li>
    <li>
      <p><span style="font-size:10pt">Weiterreichende Ma&szlig;nahmen </span></p>
    </li>
  </ul>

  <p><span style="font-size:9pt"><em>Optional: Erstellung eines Blitzschutz- und &Uuml;berspannungsschutzkonzeptes auf Basis der Risikoanalyse (separate Leistungen)</em></span></p>

</span>
</template>

<script>
export default {
  name: "TooltipRisikoanalyse"
}
</script>

<style scoped>

</style>
